// @ts-nocheck

import React, { useCallback } from 'react';
import type { Node } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

import { getPortalRootDOMElement } from '../../DOMElements';
import theme from '../../styled-components/dark';
import { Overlay } from '../Modal/Modal.style';
import ScaleTransitionGroup from '../ScaleTransitionGroup';

const Portal = styled.div`
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  width: 100%;
  z-index: ${theme.ZIndices.modal + 10};
`;

const PortalOverlay = styled(Overlay)`
  z-index: 0;
`;

const PortalContent = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 1;
`;

type OverModalProps = {
  className?: string;
  children: Node;
  isOpen: boolean;
  onClose: (...params: unknown) => unknown;
};

const OverModal = ({ className, children, isOpen, onClose }: OverModalProps) => {
  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      onClose();
    },
    [onClose],
  );

  return createPortal(
    <ScaleTransitionGroup>
      {isOpen ? (
        <Portal className={className}>
          <PortalOverlay onClick={handleClick} />
          <PortalContent className="modal-content">{children}</PortalContent>
        </Portal>
      ) : null}
    </ScaleTransitionGroup>,
    getPortalRootDOMElement(),
  );
};

export default OverModal;
